
// Logger utility for consistent logs
export const logStatsData = (message: string, data?: any) => {
  if (data) {
    console.log(`[StatsData] ${message}`, data);
  } else {
    console.log(`[StatsData] ${message}`);
  }
};
